import React from "react";
import { motion } from "framer-motion";

export const RaceInfo = ({ categoryName, description }) => {
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  const raceInclusions = {
    "MOUNTAIN UPHILL (5K)": ["Race inclusion information will be updated soon"],
    "MOUNTAIN CLASSIC (10K)": [
      "Race inclusion information will be updated soon",
    ],
    "MOUNTAIN CLASSIC JUNIOR (10K)": [
      "Race inclusion information will be updated soon",
    ],
    "SHORT TRAIL (42K)": ["Race inclusion information will be updated soon"],
    "LONG TRAIL (75K)": ["Race inclusion information will be updated soon"],
  };

  const inclusionList = raceInclusions[trimmedCategoryName];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <motion.div
        className="space-y-2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h3 className="text-lg font-bold text-gray-800">Description:</h3>
        <div className="text-gray-700 text-md leading-relaxed">
          {description ? (
            <p>{description}</p>
          ) : (
            <p>No description available.</p>
          )}
        </div>
      </motion.div>
    </div>
  );
};
